import { connect } from 'react-redux';

import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { isConversationParticipant, isCurrentConversationMCU } from 'modules/appointmentInfo/selectors/currentAppointment';

import VideoConference from './VideoConference';
import { remoteVideoConnected } from '../../selectors/connectionStatus';

const mapStateToProps = (state) => ({
  isMCU: isCurrentConversationMCU(state),
  remoteVideoConnected: remoteVideoConnected(state),
  switched: state.conference.consultationInfo.switchedLayout,
  isNeedToShowLocalVideo: conferenceInProgress(state) && isConversationParticipant(state),
});

export default connect(
  mapStateToProps,
)(VideoConference);
